import { Dispatch } from "react";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import {
  searchPush,
  updateFilter,
  updateSearch,
  updateUi,
} from "../common/actions";
import SearchPills from "../components/SearchPills";
import { Query, SearchPillData } from "../interfaces";

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    deleteSearchPill: (
      searchPill: SearchPillData,
      dataArray: SearchPillData[],
      appState?: Query,
    ) => {
      if (searchPill.search) {
        dispatch(updateSearch(searchPill.formKey, ""));
      } else if (searchPill.formKey === "multiCert") {
        dispatch(
          updateFilter(
            "multiCert",
            appState?.filters.multiCert.filter(
              (c: string) => c !== searchPill.value,
            ),
          ),
        );
      } else {
        dispatch(updateFilter(searchPill.formKey, ""));
      }

      dispatch(updateUi("updatePrevForm", true));
      dispatch(searchPush());
    },
  };
}

export default connect(null, mapDispatchToProps)(SearchPills);
